import React, { useState } from "react";
import { Link } from "react-router-dom";
import project_img from "./clientes-image.jpg";
import SaberMasButton from "../../../components/SaberMasBtn/SaberMasBtn";
import CarouselControls from "../../../components/CarouselControls/CarouselControls";
import "./HomeFirstSection.css";
import Navbar from "../../Navbar/Navbar";

import homeBg1 from "./home1.png";
import homeBg2 from "./home2.jpg";
import homeBg3 from "./home3.jpg";

const HomeFirstSection = () => {
  const sectionImages = [homeBg1, homeBg2, homeBg3];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % sectionImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + sectionImages.length) % sectionImages.length);
  };

  const goToImage = (index) => {
    setCurrentImageIndex(index);
  };

  return (
    <div className="home-page-container">
      {/* Componente Navbar */}
      <Navbar />

      {/* Fondo del carrusel */}
      <div
        className="background-container"
        style={{ backgroundImage: `url(${sectionImages[currentImageIndex]})` }}
      />

      {/* Overlay oscuro */}
      <div className="overlay-dark" />

      {/* Contenido principal */}
      <main className="home-banner">
        {/* Sección de texto principal */}
        <div className="home-text">
          <p>Bienvenido a CNgroup</p>
          <h1>
            Energía al alcance de todos.
            <span>Limpia, Accesible, Asequible</span>
          </h1>
          <p>
            CNgroup: su especialista en plantas fotovoltaicas, promoción inmobiliaria
            sostenible y obras civiles con criterios energéticos eficientes, para hacer
            posible un mañana mejor.
          </p>
          <SaberMasButton variant="hero" to="/cngroup/5" context="hero" />
        </div>

        {/* Botón combo */}
        <Link to="/clientes" className="combo-btn">
          <div className="combo-btn-image">
            <img
              src={project_img}
              alt="Nuestros proyectos"
            />
          </div>
          <div className="combo-btn-content">
            <span className="combo-subtitle">Clientes</span>
            <span className="combo-title">
              Conoce algunos de nuestros proyectos
            </span>
            <div className="combo-arrow">→</div>
          </div>
        </Link>

        {/* Controles del carrusel */}

        <div className="carousel-controls-container">
          <CarouselControls
            totalSlides={sectionImages.length}
            currentSlide={currentImageIndex}
            onNext={nextImage}
            onPrev={prevImage}
            onDotClick={goToImage}
            variant="dots"
            autoPlay={true}
            position="absolute"
          />
        </div>
      </main>
    </div>
  );
};

export default HomeFirstSection;